export default class InputAddress{
    
    constructor(element) {
        this._wrapper = element;
        this._input = this._wrapper.querySelector('.js-input-address-search');
        this._realInput = this._wrapper.querySelector('.js-input-address-input');
        this._dropdown = this._wrapper.querySelector('.js-input-address-list');
        this._loader = this._wrapper.querySelector('.js-input-address-list-loader');
        this._inputZipcode = document.querySelector('input[name="'+this._wrapper.getAttribute('data-zipcote-input')+'"]');
        this._inputCity = document.querySelector('input[name="'+this._wrapper.getAttribute('data-city-input')+'"]');
        this._inputLat = document.querySelector('input[name="'+this._wrapper.getAttribute('data-lat-input')+'"]');
        this._inputLng = document.querySelector('input[name="'+this._wrapper.getAttribute('data-lng-input')+'"]');
        
        this._acfData = false;
        
        this.bindEvents();
    }
    
    bindEvents(){
        this._input.addEventListener('input', () => {
            if(this._input.value){
                [...this._dropdown.querySelectorAll('.js-input-address-list-item')].forEach(item => item.remove());
                this._dropdown.classList.remove('d-none');
                this._loader.classList.remove('d-none');
            }
        });
        
        this._input.addEventListener('input', app.debounce(() => {
            fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(this._input.value)}&format=json&addressdetails=1&limit=5`)
                .then(response => response.json())
                .then(data => {
                    data.forEach((item,n) => {
                        let _elem = app.createElement('<span class="js-input-address-list-item">'+item.display_name+'</span>');
                        _elem = _elem[0];
                        this._dropdown.appendChild(_elem);
                        _elem.addEventListener('click', () => {
                            
                            this._input.value = item.display_name;
                            let value = this.transformNominatimToACF(item);
                            this._realInput.value = JSON.stringify(value);

                            this._inputZipcode.value = item.address.postcode;
                            this._inputLng.value = item.lon;
                            this._inputLat.value = item.lat;
                            
                            //Nominatim is a bit random
                            if(item.address.city){
                                this._inputCity.value = item.address.city;
                            }
                            else if(item.address.village){
                                this._inputCity.value = item.address.village;
                            }
                            else if(item.address.town){
                                this._inputCity.value = item.address.town;
                            }
                            else if(item.address.municipality){
                                this._inputCity.value = item.address.municipality;
                            }
                            
                            
                            this.closeDropdown(); 
                        });
                    })
                    this._loader.classList.add('d-none');
                    // this._acfData = this.transformNominatimToACF(data[0]);
                })
                .catch(err => {
                    console.log(err);
                });
        }, 1500));
    }

    transformNominatimToACF(place) {
        const lat = parseFloat(place.lat);
        const lng = parseFloat(place.lon);

        const bbox = {
            _southWest: {
                lat: parseFloat(place.boundingbox[0]),
                lng: parseFloat(place.boundingbox[2]),
            },
            _northEast: {
                lat: parseFloat(place.boundingbox[1]),
                lng: parseFloat(place.boundingbox[3]),
            },
        };

        const geocode = [{
            name: place.display_name,
            html: place.display_name,
            bbox,
            center: { lat, lng },
            properties: {
                place_id: place.place_id,
                licence: place.licence,
                osm_type: place.osm_type,
                osm_id: place.osm_id,
                lat,
                lon: lng,
                class: place.class,
                type: place.type,
                place_rank: place.place_rank,
                importance: place.importance,
                addresstype: place.addresstype,
                name: place.address?.road || place.address?.pedestrian || place.address?.footway || '',
                display_name: place.display_name,
                address: place.address,
                boundingbox: place.boundingbox.map(parseFloat),
            }
        }];

        return {
            lat,
            lng,
            zoom: 12,
            markers: [
                {
                    label: place.display_name,
                    default_label: place.display_name,
                    lat,
                    lng,
                    geocode,
                    uuid: 'marker_' + Math.random().toString(36).slice(2, 12),
                }
            ],
            address: place.display_name,
            layers: ['OpenStreetMap.Mapnik'],
            version: '1.6.1',
        };
    }
    
    closeDropdown(){
        this._dropdown.classList.add('d-none');
        this._loader.classList.add('d-none');
    }
}